(function ($) {
  /* -- Wait for dynamic element -- */
  const onReadyDomElement = function (element, callback) {
    if (jQuery(element).length) {
      callback(jQuery(element));
    } else {
      setTimeout(function () {
        onReadyDomElement(element, callback);
      }, 100);
    }
  };

  /* -- Bazaar voice reviews -- */
  function modifyReviews() {
    onReadyDomElement( '#bv_review_maincontainer', function (e) {
        e.each(function () {
          $(this).addClass('bv-override');
          $(this).parents('#reviews').fadeIn();
          $(this).parents('#reviews').find('.bv-stars-skeleton').fadeOut('slow', function() {
            $(this).parents('#reviews').find('.bv-reviews-wrapper').fadeIn('slow');
            $(this).parents('#reviews').find('.bv-stars-skeleton').remove();
          });
        });
      }
    );
  }

  function modifyInlineStars() {
    onReadyDomElement( '[class*="bv_inline_rating_container"]', function (e) {
        e.each(function () {
          $(this).addClass('bv-star-override');
          $(this).parents('.star-widget-wrapper').find('.bv-stars-skeleton').fadeOut('slow', function() {
            $(this).parents('.star-widget-wrapper').find('.star-widget').fadeIn('slow');
            $(this).parents('.star-widget-wrapper').find('.bv-stars-skeleton').remove();
          });
        });
      }
    );
  }
  
  if ($('.template-product').length) {
    modifyReviews();
  }

  if ($('.star-widget').length) {
    modifyInlineStars();
  }

  /* -- Redeem LP -- */
  function checkPromoCode($pageTitle, url, urlPromoCode) {
    if (url.indexOf($pageTitle + '/') > -1) {
      urlPromoCode = url.split($pageTitle + '/')[1];
    }

    if (urlPromoCode.indexOf("#") > -1 && urlPromoCode !== '') {
      urlPromoCode = urlPromoCode.split('#')[0];
    }

    if (urlPromoCode.indexOf("?") > -1) {
      urlPromoCode = urlPromoCode.split('?')[1];
    }

    if (urlPromoCode !== '') {
      $('#redeem-form-section [name="customer[promotion_code]"]').val(urlPromoCode);

      return urlPromoCode;
    }

  }

  function buildCustomerTags(redeemLpTag, $uniqueCode, $pregnancyStage, $dueDateOrBirthDate) {
    const uniqueCodeTag = $uniqueCode !== '' ? ', Unique Code: '+$uniqueCode : '';
    const pregnancyStageTag = typeof $pregnancyStage !== 'undefined' ? ', '+$pregnancyStage : '';
    const dueDateOrBirthDateTag = $dueDateOrBirthDate !== '' ? ', Birth/Due Date: '+$dueDateOrBirthDate : '';

    const tagString = redeemLpTag+uniqueCodeTag+pregnancyStageTag+dueDateOrBirthDateTag;
    return tagString;
  }

  if ($('#redeem-form-section').length) {
    $('body').addClass('redeem-lp');

    const $pageTitle = $('#redeem-form-section').data('page-slug');
    const returnTo = '/pages/' + $pageTitle + '/';    
    const url = window.location.href;
    let urlPromoCode = '';

    const $customerTags = $('#redeem-form-section [name="customer[tags]"]');
    const redeemLpTag = 'Subscribed from: ' + $pageTitle;
    let $uniqueCode = checkPromoCode($pageTitle, url, urlPromoCode) || '';
    let $pregnancyStage = $('#redeem-form-section [name="customer[pregnancy_stage]"]').val();
    let $dueDateOrBirthDate = '';

    $customerTags.val(buildCustomerTags(redeemLpTag, $uniqueCode, $pregnancyStage, $dueDateOrBirthDate));

    $('#redeem-form-section [name="customer[promotion_code]"]').on('keyup', function() {
      $('[name="return_to"]').val(returnTo+$(this).val()+'#submitted');
      $customerTags.val(redeemLpTag+', Unique Code: '+$(this).val());
      
      $uniqueCode = $(this).val();
      $customerTags.val(buildCustomerTags(redeemLpTag, $uniqueCode, $pregnancyStage, $dueDateOrBirthDate));
    });

    $('#redeem-form-section [name="customer[pregnancy_stage]"]').on('change', function() {
      $pregnancyStage = $(this).val();
      $customerTags.val(buildCustomerTags(redeemLpTag, $uniqueCode, $pregnancyStage, $dueDateOrBirthDate));
    });

    $('#redeem-form-section [name="customer[due_date_or_birth_date]"]').on('change', function() {
      $dueDateOrBirthDate = $(this).val();
      $customerTags.val(buildCustomerTags(redeemLpTag, $uniqueCode, $pregnancyStage, $dueDateOrBirthDate));
    });
  }

})(jQuery);

function debounce(func, wait) {
  let timeout;
  return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ResponsiveVideo extends HTMLElement {
  constructor() {
    super();
    this.videoElement = this.querySelector("video");
    this.mobileSrc = this.getAttribute("data-mobile-src");
    this.desktopSrc = this.getAttribute("data-desktop-src");
    this.onResize = debounce(this.updateVideoSource.bind(this), 200);
    this.currentSrc = null; // Track the current video source

    this.volumeButton = this.querySelector(".responsive-video__volume-btn");

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
      }
    );
  }

  connectedCallback() {
    this.observer.observe(this);
    window.addEventListener("resize", this.onResize);
    this.updateVideoSource(); // Initial update to ensure video is set correctly

    if (this.volumeButton) {
      this.volumeButton.addEventListener("click", this.toggleVolume.bind(this));
    }
  }

  disconnectedCallback() {
    this.observer.unobserve(this);
    window.removeEventListener("resize", this.onResize);
    if (this.volumeButton) {
      this.volumeButton.removeEventListener("click", this.toggleVolume.bind(this));
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadVideo();
        this.videoElement.play();
      } else {
        this.videoElement.pause();
      }
    });
  }

  updateVideoSource() {
    // Ensure video source is updated based on current viewport size
    this.loadVideo();
  }

  loadVideo() {
    const newSrc = this.getCurrentVideoSrc();
    if (newSrc !== this.currentSrc) {
      this.currentSrc = newSrc;
      this.videoElement.src = newSrc;
    }
  }

  getCurrentVideoSrc() {
    if (window.innerWidth > 769) {
      return this.desktopSrc;
    }
    return this.mobileSrc || this.desktopSrc; // Default to desktopSrc if mobileSrc is not defined
  }

  toggleVolume() {
    if (this.videoElement.muted) {
      this.videoElement.muted = false;
      this.volumeButton.classList.remove('volume-muted');
    } else {
      this.videoElement.muted = true;
      this.volumeButton.classList.add('volume-muted');
    }
  }
}
customElements.define("responsive-video", ResponsiveVideo);

function checkHeaderOverlay() {
  const siteHeader = document.getElementById('SiteHeader');

  if (siteHeader && siteHeader.getAttribute('data-overlay') === 'true' && window.matchMedia('(min-width: 769px)').matches) {
    document.body.classList.add('header-overlay-active');
  }
  else {
    document.body.classList.remove('header-overlay-active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Scroll to target ID
  document.querySelectorAll('[data-scrolltoid]').forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      const targetId = element.getAttribute('data-scrolltoid').slice(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offset = -100;
        const yPosition = targetElement.getBoundingClientRect().top + window.scrollY + offset;
        window.scrollTo({ top: yPosition, behavior: "smooth" });
      }
    });
  });

  checkHeaderOverlay();
  new StickyBarHandler(); 
});

window.addEventListener('resize', debounce(checkHeaderOverlay, 200));

// Displays product sticky bar when main add to cart button is not visible on the screen
class StickyBarHandler {
  constructor() {
    this.stickyBar = document.querySelector('[data-sticky-bar');
    this.mainProductForm = this.stickyBar ? document.getElementById(this.stickyBar.dataset.mainFormId) : null;
    this.mainProductForm ? this.init() : null;
  }

  init() {
    this.observer = new IntersectionObserver(
      ([entry]) => this.stickyBar.classList.toggle('active', !entry.isIntersecting),
      { rootMargin: '0px', threshold: 0 }
    );
    this.observer.observe(this.mainProductForm);
  }
}

function gorgiasLoaded() {
  const interval = setInterval(() => {
      const chatContainer = document.getElementById('chat-button');
      if (chatContainer) {
          chatContainer.classList.add('gorgias-override');
          console.log('gorgias-chat-container found');
          clearInterval(interval);
      }
  }, 100);
}

const scriptElement = document.querySelector('script#gorgias-chat-widget-install-v3');
if (scriptElement) {
  gorgiasLoaded();
}
